<div *ngIf="loader==true">
    <app-loader style="text-align: center;"></app-loader>
  </div>
<div class="container mt-5">
    <div class="row">
        <div class="col-lg-3">
            <p>600 Broadway</p>
            <p>STE 200 #2269, Albany</p>
            <p>New York 12207</p>
        </div>
        <div class="col-lg-6"></div>
        <div class="col-lg-3">
            Retailer Name: <b>{{printData.retailerName}}</b><br><br>
            Invoice No: #{{printData.invoiceNo}} <br><br>
            Start Date: {{printData.startDate}} <br><br>
            End Date: {{printData.endDate}}
        </div>
    </div>
    <hr><hr>
    <div class="row">
        <div class="col-lg-12">
            <table class="table table-responsice">
                <thead>
                    <th>Date</th>
                    <th>Order Number</th>
                    <th>Retail Price</th>
                    <th>Quantity</th>
                    <th>Product</th>
                    <th>Total</th>   
                </thead>
                <tbody>
                    <tr *ngFor="let item of printData.exportInvoiceItems">
                        <td>{{item.date | date:'MM/dd/yyyy'}}</td>
                        <td>{{item.orderNumber}}</td>
                        <td>{{item.retailPrice}}</td>
                        <td>{{item.quantity}}</td>
                        <td>{{item.product}}</td>
                        <td>${{item.total}}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table" style="background-color: rgb(232, 229, 229);">
                <tr>
                    <th>SUBTOTAL</th>
                    <th>DISCOUNT</th>
                    <th>Paid</th>
                    <th>Due</th>
                    <th style="color: rgb(248, 7, 7);">Cancelled</th>
                    <th>TOTAL</th>
                </tr>
                    <tr>
                        <th>${{printData.subTotal}}</th>
                        <th>${{printData.discount}}</th>
                        <th>${{printData.paid}}</th>
                        <th>${{printData.due}}</th>
                        <th style="color: rgb(248, 7, 7);">${{printData.cancled}}</th>
                        <th>${{printData.total}}</th>
                    </tr>
                    <tr>
                        <td colspan="6" style="text-align: center;"><br><br>
                            THANK YOU FOR YOUR BUSINESS <br><br>
                            Website: www.prid.io<br>
                        </td>
                    </tr>
            </table>
        </div>
    </div>
</div>